module.exports = __webpack_public_path__ + "img/top_banner3.423c4186.png";